import React, { Component } from 'react';
 import "./publicright.css"
import TimeAgo from 'react-timeago'
class Publicright extends Component {
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
            <div className="Publicright"> 
               <div className="aticle-body">  
                    <div className="aticle-sub">  
                         <p className="aticle-date"> <TimeAgo date={this.props.date} /></p>
                        <i className="fas fa-user-tie icon-link"></i>   {this.props.name}
                    </div>
                    <div className="notice-title-body-head">  <p>{this.props.title}</p></div>
                         <p>{this.props.body}</p>
                    </div>
                    <hr/>
           </div>     

    )

}





}

export default Publicright;



// WEBPACK FOOTER //
// ./src/component/public/publicright.js